<template>
  <div class="postsContainer col-12 col-lg-10 col-xl-6 row justify-content-center" v-if="this.posts">
    <div class="postContainer col-12 col-md-6" v-for="( post, index ) in this.posts" :key="index">
      <div class="postFeaturedImage">
        <img
        v-if="post.featured_media != 0"
        :src='post._embedded["wp:featuredmedia"][0].media_details.sizes.medium.source_url'
        >
      </div>
      <div class="post">
          <router-link :to="{ name: 'post', params: {postId: post.id}, query:{backName:'Blogs', title: post.title.rendered, backRoute: $route.fullPath, location: $route.params.location}}">
            <h2 v-html="post.title.rendered"></h2>
          </router-link>
          <div class="spacer"></div>
          <p v-html="post.excerpt.rendered"></p>
          <router-link
            :to="{ name: 'post', params: {postId: post.id}, query:{backName:'Blogs', title: post.title.rendered, backRoute: $route.fullPath, location: $route.params.location}}"
            class="readMore"
          >
            Read More &gt;
          </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { fetchBlogPosts } from '@/network/wordpressRequests'

export default {
  name: 'BlogPage',
  components: {

  },
  data(){
    return {
      posts: null
    }
  },
  mounted(){
    fetchBlogPosts(result => {
      this.posts = result
    })
  },
}
</script>

<style lang="scss" scoped>
  .postsContainer{
    margin: 30px auto;
  }

  .postContainer{
    width: 350px;
    //margin: 0 15px 15px 0;
    margin: 10px 0 10px;
  }
  .postFeaturedImage img{
    width: 100%;
  }

  .post{
    box-sizing: border-box;
    padding: 30px 25px 20px;
    line-height: 1.87;
    border:1px solid #eaeaea;
    border-bottom-width:3px;
  }

  h2{
    font-size: 26pt;
    line-height: 36pt;
    color: #AF272F;
  }

  .spacer{
    border-top: #eaeaea 1px solid;
    border-bottom: #eaeaea 1px solid;
    height: 6px;
    margin: 10px 0;
  }

  a{
    color: #AF272F;
    &:hover:not(.readMore){
      text-decoration: none;
    }
  }
</style>
